/* Express Shipping Banner init (idempotent) */
window.__ESB_LOADED__ || (window.__ESB_LOADED__ = (function(){

  function parseHolidayList(str){
    return (str||'').split(',').map(s=>s.trim()).filter(Boolean);
  }
  function isBankHoliday(date, list){
    if(!Array.isArray(list)) return false;
    const y=date.getFullYear(), m=String(date.getMonth()+1).padStart(2,'0'), d=String(date.getDate()).padStart(2,'0');
    return list.includes(`${y}-${m}-${d}`);
  }
  function isWorkingDay(date, holidays){
    const day=date.getDay();
    return day!==0 && day!==6 && !isBankHoliday(date, holidays);
  }
  function startOfDay(date){
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
  function addDays(date, n){
    const d=new Date(date);
    d.setDate(d.getDate()+n);
    return d;
  }
  function nextWorkingDay(fromDate, holidays){
    // returns the next working day strictly AFTER fromDate
    let d = addDays(startOfDay(fromDate), 1);
    while(!isWorkingDay(d, holidays)) d = addDays(d, 1);
    return d;
  }

  function getDispatchDate(now, cutoffHour, holidays){
    const today = startOfDay(now);
    const cutoff = new Date(today); cutoff.setHours(cutoffHour,0,0,0);
    if (now < cutoff && isWorkingDay(today, holidays)){
      return today; // dispatch today
    }
    // else dispatch next working day
    let d = nextWorkingDay(today, holidays);
    return d;
  }

  function getDeliveryDate(dispatchDate, holidays){
    // delivery is next working day after dispatch
    return nextWorkingDay(dispatchDate, holidays);
  }

  function computeDeliveryLabel(now, deliveryDate){
    const dayNames = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    const today = startOfDay(now);
    const tomorrow = addDays(today, 1);
    const isTomorrow =
      startOfDay(deliveryDate).getTime() === tomorrow.getTime();

    // If literally tomorrow, say "Tomorrow". Otherwise use day name.
    return isTomorrow ? 'Tomorrow' : dayNames[deliveryDate.getDay()];
  }

  function initOne(root){
    if(root.__esbInit) return; root.__esbInit = true;

    const cutoff = parseInt(root.getAttribute('data-cutoff')||'15',10);
    const holidays = parseHolidayList(root.getAttribute('data-bank-holidays'));

    const h = root.querySelector('.es-num.es-h') || root.querySelector('.es-h') || root.querySelector('#hours');
    const m = root.querySelector('.es-num.es-m') || root.querySelector('.es-m') || root.querySelector('#minutes');
    const s = root.querySelector('.es-num.es-s') || root.querySelector('.es-s') || root.querySelector('#seconds');
    const headlineEl = root.closest('.es-banner')?.querySelector('.es-headline');

    function tick(){
      const now = new Date();

      // Calculate dispatch & delivery dates with working-day rules
      const dispatchDate  = getDispatchDate(now, cutoff, holidays);
      const deliveryDate  = getDeliveryDate(dispatchDate, holidays);

// Update headline copy dynamically
      if (headlineEl){
        const label = computeDeliveryLabel(now, deliveryDate);
        
        // Check if screen is mobile (less than or equal to 768px)
        if (window.innerWidth <= 768) {
           // MOBILE TEXT: Short and punchy
           headlineEl.textContent = `Get It ${label}, Order Within`; 
        } else {
           // DESKTOP TEXT: Full sentence
           headlineEl.textContent = `For Delivery ${label}, Order Within`;
        }
      }

      // Countdown deadline: 3pm of the next valid ORDER cutoff
      // (same logic you had: counts down to the next time you can place an order)
      const today = startOfDay(now);
      let deadline = new Date(today); deadline.setHours(cutoff,0,0,0);
      if (now >= deadline) {
        // move to next potential ordering day
        deadline = nextWorkingDay(today, holidays);
        deadline.setHours(cutoff,0,0,0);
      }
      // Ensure ordering deadline is a working day
      while(!isWorkingDay(startOfDay(deadline), holidays)){
        const base = startOfDay(deadline);
        deadline = nextWorkingDay(base, holidays);
        deadline.setHours(cutoff,0,0,0);
      }

      let diff = deadline - now;
      if (diff <= 0){
        // safety: recompute on edge rollover
        const nd = getDispatchDate(now, cutoff, holidays);
        const dl = getDeliveryDate(nd, holidays);
        if (headlineEl){
          const lbl = computeDeliveryLabel(now, dl);
          headlineEl.textContent = `For Delivery ${lbl}, Order Within`;
        }
        diff = Math.max(0, deadline - now);
      }

      const hrs = Math.floor(diff / (1000*60*60));
      const mins = Math.floor((diff % (1000*60*60)) / (1000*60));
      const secs = Math.floor((diff % (1000*60)) / 1000);

      if(h) h.textContent = String(hrs).padStart(2,'0');
      if(m) m.textContent = String(mins).padStart(2,'0');
      if(s) s.textContent = String(secs).padStart(2,'0');
    }

    tick();
    root.__esbInterval = setInterval(tick, 1000);
  }

  function initAll(){
    document.querySelectorAll('.es-banner .es-body').forEach(initOne);
  }

  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', initAll); }
  else { initAll(); }

  return true;
})());
